
<template>
	<div id="app">
		<el-select v-model="ycbx" value-key="xkzj">
			<el-option v-for="item1 in gradeOptions" :value="{xkzj:item1.xk,ymt:item1.gradeName}"  :key="item1.grade" :label="item1.gradeName"></el-option>
		</el-select>
		<el-select v-model="InWindowPositionType">
			<el-option v-for="item in positionList" :value="item" :key="item.value" :label="item.label"></el-option>
		</el-select>
	</div>
</template>
 
<script>
import { postData, getData, postJson } from "@/http/fetch.js";
import { mapState, mapGetters } from "vuex";
export default {
	computed: {
		...mapState(["userInfo"])
	},
	data() {
		return {
			InWindowPositionType: "",
			positionList: [
				{ value: 1, label: "java", name: "加瓦" },
				{ value: 2, label: "node", name: "诺德" },
				{ value: 3, label: "python", name: "派森" }
			],
			gradeOptions: [
				{
					xk:"语文",
					grade: 1,
					gradeName: "一年级"
				},
				{
					xk:"数学",
					grade: 2,
					gradeName: "二年级"
				}
			],
			ycbx: ""
		};
	},
	created() {
		this.getGetGradeList();
	},
	methods: {
		async getGetGradeList() {
			// this.gradeOptions = await postData("/school/getGradeList", {
			// 	schoolCode: this.userInfo.schoolCode
			// });
		}
	}
};
</script>
 
<style>
.menu {
	position: fixed;
	width: 200px;
	background-color: #eee;
}
.content {
	width: 500px;
	height: 500px;
	margin-left: 300px;
	margin-bottom: 50px;
	background-color: #f5f5f5;
	border: 1px solid #ddd;
}
</style>
